import React, { useEffect } from 'react'
import { Typography, Box } from '@mui/material'
import Layout from './Layout'
import { useSelectedDataRoom } from 'hooks/useSelectedDataRoom'

export default function AccessDataRoom({ setShowAccessIframe, setIframeRoom }) {
  const { dataRoom } = useSelectedDataRoom()

  useEffect(() => {
    setShowAccessIframe(true)
    if (dataRoom) setIframeRoom(dataRoom.data_room)
    return () => setShowAccessIframe(false)
  }, [dataRoom, setShowAccessIframe, setIframeRoom])

  return <Layout>
    {!dataRoom && <Box><Typography variant='h5'>Please select a data room</Typography></Box>}
  </Layout>

}
